import {
  DeleteOutlineOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined,
} from "@material-ui/icons";
import {
  Box,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useToast from "../../../../hooks/useToast";
import useConfirm from "../../../../hooks/useConfirm";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";
import { AssociationService } from "../../../../service/AssociationService";

const AssociationList = ({ selection = false, id_type, handleSelectedCV }) => {
  const [associations, setAssociations] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const navigate = useNavigate();
  const [filtre, setFiltre] = useState({});
  const { Toast, showToast } = useToast();
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const HanldeDeleteAssociation = (id) => {
    AssociationService.deleteSeletedAssociation(id).then((res) => {
      if (res && res.success) {
        handleFetchAssociationList();
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
      }
    });
  };

  const handleConfirmDeleteRow = (id) => {
    openConfirmDialog(
      "Confirmation",
      "Voulez-vous vraiment supprimer cette association ?",
      () => {
        HanldeDeleteAssociation(id);
      }
    );
  };

  const handleFetchAssociationList = () => {
    setDataLoading(true);
    AssociationService.getAllSelectedAssociation(filtre)
      .then((res) => {
        if (res && res.data) {
          setAssociations(res.data);
          setFilteredRows(res.data);
        } else {
          setAssociations([]);
          setFilteredRows([]);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleShowMemebre = (uuid) => {
    navigate(`membres?ref=${uuid}`);
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(associations);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      associations.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot)
          )
        )
      )
    );
  };

  const table_colonne = [
    {
      field: "nom",
      headerName: "Nom de l'association",
      flex: 1,
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "adresse",
      headerName: "Localisation",
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "annee_creation",
      headerName: "Année de création",
      minWidth: 150,
    },
    {
      field: "created_at",
      headerName: "Date de création",
      minWidth: 120,
    },
    {
      field: "num_nif",
      headerName: "NIF",
      minWidth: 120,
    },
    {
      field: "num_stat",
      headerName: "STAT",
      minWidth: 120,
    },
    {
      field: "nb_membre",
      headerName: "Membres",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Afficher membres"
              color="primary"
              onClick={(e) => handleShowMemebre(params.row.uuid)}
            >
              <RemoveRedEyeOutlined />
            </IconButton>
            <IconButton
              title="Supprimer Association"
              color="error"
              onClick={(e) =>
                handleConfirmDeleteRow(params.row.id_ext_selected_asso)
              }
            >
              <DeleteOutlineOutlined />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchAssociationList();
  }, []);

  return (
    <>
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Liste des associations gérées"
              action={
                <Grid container spacing={1}>
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      onChange={(e) => handleFilter(e.target.value)}
                      placeholder="Recherche"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      color="primary"
                      onClick={handleFetchAssociationList}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                rows={filteredRows}
                getRowId={(row) => row.id_ext_association}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default AssociationList;
